export default __webpack_public_path__ + "static/media/No.1-7.ebf9211c.jpg";